export default __webpack_public_path__ + "static/getADemo-6dbd6787a5c4182660dfd8f5f0be0e08.png";